import styled, { keyframes } from 'styled-components';
import Close from '@carvana/icons/Close';
import { AlertCircle, CheckCircle } from '@carvana/icons';

const toastFadeIn = () => {
  return keyframes`
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  `;
};

export const ToastOutsiderAlert = styled.div``;

export const ToastWrapper = styled.div`
  background: ${(props: any) => props.theme.carvana.blue.dark};
  position: fixed;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  padding: 15px;
  padding-top: 17px;
  border-radius: 3px;
  z-index: 1500;
  display: block;
  width: 282px;
  min-height: 140px;
  font-size: 16px;
  line-height: 20px;
  animation: ${toastFadeIn} 300ms ease-in-out;
  transition:
    transform 300ms ease-in-out,
    opacity 300ms ease-in-out;
  box-shadow:
    0px 3px 5px -1px rgba(0, 0, 0, 0.2),
    0px 1px 15px 0px rgba(0, 0, 0, 0.12);
  text-align: center;

  &::after {
    position: static;
    content: '';
    background: green;
    z-index: 10;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100vh;
    width: 100vw;
  }

  @media (min-width: ${(props: any) => props.theme.breakpoints.values.sm}px) {
    transform: translate(118px, 210px);
    top: initial;
    left: initial;
  }

  @media (min-width: ${(props: any) => props.theme.breakpoints.values.md}px) {
    transform: translate(199px, 210px);
  }

  @media (min-width: ${(props: any) => props.theme.breakpoints.values.lg}px) {
    transform: translate(338px, 210px);
  }

  &.on-leave {
    opacity: 0;
  }
`;

export const ToastTitle = styled.div`
  margin: 9px 15px;
  font-weight: 700;
  font-size: 18px;
  color: ${(props: any) => props.theme.carvana.white.primary};
`;

export const ToastText = styled.div`
  font-size: 14px;
  color: ${(props: any) => props.theme.carvana.white.primary};
`;

export const SuccessIcon = styled(CheckCircle)`
  color: ${(props: any) => props.theme.carvana.green.primary};
`;

export const ErrorIcon = styled(AlertCircle)`
  color: ${(props: any) => props.theme.carvana.red.primary};
`;

export const CloseIconWrapper = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  height: 40px;
  width: 40px;
  background: transparent;
  z-index: 4;
  cursor: pointer;
`;

export const CloseIcon = styled(Close)`
  color: ${(p: any) => p.theme.carvana.white.primary};
  top: 10px;
  z-index: 2;
`;
